export default __webpack_public_path__ + "static/media/login_student-image.01e38bf7.png";